import { tokenizer } from "./tokenizer.js";
import { isAddExtendedProperty, isAlterTableAdd, isAlterTableAddDefault, isAlterTableAddForeignKey, isAlterTableAddPrimaryKey, isAlterTableAlter, isCommentOnColumn, isCommentOnTable, isCreateIndex, isCreateTable } from "./helper.js";
import { addExtendedPropertyParser } from "./statement/add.extended.property.js";
import { alterTableAddDefaultParser } from "./statement/alter.table.add.default.js";
import { createTableParser } from "./statement/create.table.js";
import { alterTableAddForeignKeyParser } from "./statement/alter.table.add.foreignKey.js";
import { alterTableAddPrimaryKeyParser } from "./statement/alter.table.add.primaryKey.js";
import { alterTableAddUniqueParser } from "./statement/alter.table.add.unique.js";
import { alterTableAlterColumnParser } from "./statement/alter.table.alter.column.js";
import { commentOnColumnParser } from "./statement/comment.on.column.js";
import { commentOnTableParser } from "./statement/comment.on.table.js";
import { createIndexParser } from "./statement/create.index.js";
//#region ../schema-sql-parser/dist/parser/index.js
function parser(tokens, database) {
	const ast = [];
	const $pos = { value: 0 };
	const isToken = () => $pos.value < tokens.length;
	const createTable = isCreateTable(tokens);
	const createIndex = isCreateIndex(tokens);
	const alterTableAddPrimaryKey = isAlterTableAddPrimaryKey(tokens);
	const alterTableAddForeignKey = isAlterTableAddForeignKey(tokens);
	const alterTableAddDefault = isAlterTableAddDefault(tokens);
	const alterTableAdd = isAlterTableAdd(tokens);
	const alterTableAlter = isAlterTableAlter(tokens);
	const commentOnTable = isCommentOnTable(tokens);
	const commentOnColumn = isCommentOnColumn(tokens);
	const addExtendedProperty = isAddExtendedProperty(tokens);
	while (isToken()) {
		if (createTable($pos.value)) {
			ast.push(createTableParser(tokens, $pos, database));
			continue;
		}
		if (createIndex($pos.value)) {
			ast.push(createIndexParser(tokens, $pos));
			continue;
		}
		if (alterTableAdd($pos.value)) {
			const start = $pos.value;
			if (alterTableAddPrimaryKey(start)) ast.push(alterTableAddPrimaryKeyParser(tokens, $pos));
			else if (alterTableAddForeignKey(start)) ast.push(alterTableAddForeignKeyParser(tokens, $pos));
			else if (alterTableAddDefault(start)) ast.push(alterTableAddDefaultParser(tokens, $pos, database));
			const $unique = { value: start };
			ast.push(...alterTableAddUniqueParser(tokens, $unique));
			$pos.value = Math.max($pos.value, $unique.value);
			continue;
		}
		if (alterTableAlter($pos.value)) {
			ast.push(...alterTableAlterColumnParser(tokens, $pos));
			continue;
		}
		if (commentOnTable($pos.value)) {
			ast.push(commentOnTableParser(tokens, $pos));
			continue;
		}
		if (commentOnColumn($pos.value)) {
			ast.push(commentOnColumnParser(tokens, $pos));
			continue;
		}
		if (addExtendedProperty($pos.value)) {
			const comment = addExtendedPropertyParser(tokens, $pos);
			if (comment) ast.push(comment);
			continue;
		}
		$pos.value++;
	}
	return ast;
}
var schemaSQLParser = (source, { database } = {}) => parser(tokenizer(source, database), database);
//#endregion
export { schemaSQLParser };
